import {
    CadNextNotificationEntityEnumType,
    CadNextNotificationPriorityEnumType,
    CadNextNotificationTypeEnumType,
} from '@mark43/cad-api';
import { colors } from '../colors/colors';

export const eventNotificationPriorityToColors: Record<
    CadNextNotificationPriorityEnumType,
    { notchOrText: string; highlight: string }
> = {
    HIGH: {
        notchOrText: colors.eventNotificationsHighText,
        highlight: colors.eventNotificationsHighBackground,
    },
    STANDARD: {
        notchOrText: colors.eventNotificationsStandardText,
        highlight: colors.eventNotificationsStandardBackground,
    },
};

export const eventNotificationDisplayNames: Record<CadNextNotificationTypeEnumType, string> = {
    NEW_EVENT: 'New Event',
    NARRATIVE: 'Narrative',
    LOCATION_CAUTION: 'Location Caution',
    ADDITIONAL_CFS: 'Additional CFS',
    ADDITIONAL_RADIO_CHANNEL: 'Additional Radio Channel',
    ASSOCIATED_EVENT: 'Associated Event',
    ALARM_LEVEL: 'Alarm Level',
    AGENCY: 'Agency',
    BEAT: '', // this string is populated by a configurable value in useEventNotificationEnum
    CFS: 'Call For Service',
    CROSS_STREETS: 'Cross Streets',
    DISPATCH_AREA: 'Dispatch Area',
    NEW_DRUGS: 'New Drug',
    DRUGS_DRUG_CATEGORY: 'Drug Category',
    DRUGS_DESCRIPTION: 'Drug Description',
    DRUGS_IDENTIFIER: 'Drug Identifier',
    DRUGS_IDENTIFIER_TYPE: 'Drug Identifier_Type',
    DRUGS_IDENTIFIER_TYPE_OTHER_DESCRIPTION: 'Drug Identifier Type OtherDescription',
    DRUGS_IS_PRECURSOR_CHEMICAL: 'Drug Is Precursor Chemical',
    DRUGS_MEASUREMENT_UNITS: 'Drug Measurement Units',
    DRUGS_QUANTITY: 'Drug Quantity',
    EVENT_LABELS: 'Event Labels',
    EVENT_LOCATION: 'Event Location',
    EVENT_LOCATION_SUB_PREMISE: 'Event Location Sub-premise',
    EVENT_LOCATION_NOTES: 'Event Location Notes',
    EVENT_MERGED: 'Event Merged',
    EVENT_UNMERGED: 'Event Unmerged',
    NEW_FIREARM: 'New Firearm',
    FIREARM_ALTERATION_INDICATED: 'Firearm Alteration Indicated',
    FIREARM_CALIBER: 'Firearm Caliber',
    FIREARM_FIREARM_TYPE: 'Firearm Type',
    FIREARM_MAKE: 'Firearm Make',
    FIREARM_DESCRIPTION: 'Firearm Description',
    FIREARM_IDENTIFIER: 'Firearm Identifier',
    FIREARM_IDENTIFIER_TYPE: 'Firearm Identifier Type',
    FIREARM_IDENTIFIER_TYPE_OTHER_DESCRIPTION: 'Firearm Identifier Type Other Description',
    FIREARM_MODEL: 'Firearm Model',
    FIREARM_REGISTRATION_NUMBER: 'Firearm Registration_Number',
    FIREARM_SERIAL_NUMBER: 'Firearm Serial Number',
    SUBDIVISION: 'Subdivision',
    RADIO_CHANNEL: 'Radio Channel',
    EVENT_PRIORITY: 'Event Priority',
    NEW_REPORTING_PARTY: 'New Reporting Party',
    PHONE_CALL_GPS: 'Phone Call GPS',
    PHONE_CALL_CALLER_ADDRESS: 'Phone Call Caller Address',
    PHONE_CALL_CALLER_NAME: 'Phone Call Caller Name',
    REPORTING_PARTY_FIRST_NAME: 'Person First Name',
    REPORTING_PARTY_LAST_NAME: 'Person Last Name',
    REPORTING_PARTY_LOCATION: 'Person Location',
    REPORTING_PARTY_PHONE_NUMBER: 'Person Phone Number',
    REPORTING_PARTY_LOCATION_SUB_PREMISE: 'Reporting Party Location Sub-premise',
    REPORTING_PARTY_NOTES: 'Reporting Party Notes',
    REPORTING_PARTY_AGE_MAX: 'Reporting Party Age Max',
    REPORTING_PARTY_AGE_MIN: 'Reporting Party Age Min',
    REPORTING_PARTY_DATE_OF_BIRTH: 'Reporting Party Date of Birth',
    REPORTING_PARTY_DATE_OF_BIRTH_UNKNOWN: 'Reporting Party Date of Birth Unknown',
    REPORTING_PARTY_DRIVERS_LICENSE_NUMBER: 'Reporting Party License Number',
    REPORTING_PARTY_DRIVERS_LICENSE_STATE: 'Reporting Party License State',
    REPORTING_PARTY_EYE_COLOR: 'Reporting Party Eye Color',
    REPORTING_PARTY_HAIR_COLOR: 'Reporting Party Hair Color',
    REPORTING_PARTY_INVOLVEMENT_TYPE: 'Reporting Party Involvement Type',
    REPORTING_PARTY_PHONE_EXTENSION: 'Reporting Party Phone Extension',
    REPORTING_PARTY_RACE: 'Reporting Party Race',
    REPORTING_PARTY_SEX: 'Reporting Party Sex',
    REPORTING_PARTY_HEIGHT: 'Reporting Party Height',
    REPORTING_PARTY_HEIGHT_MAX: 'Reporting Party Max Height',
    REPORTING_PARTY_HEIGHT_MIN: 'Reporting Party Min Height',
    REPORTING_PARTY_WEIGHT: 'Reporting Party Weight',
    REPORTING_PARTY_WEIGHT_MAX: 'Reporting Party Weight Max',
    REPORTING_PARTY_WEIGHT_MIN: 'Reporting Party Weight Min',
    REPORTING_PARTY_SOCIAL_SECURITY_NUMBER: 'Reporting Party Social Security Number',
    REPORTING_PARTY_ADDRESS: 'Reporting Party Address',
    REPORTING_PARTY_ADDRESS_SUB_PREMISE: 'Reporting Party Address Sub-premise',
    NEW_INVOLVED_PERSON: 'New Involved Person',
    INVOLVED_PERSON_MASTER_SEARCH_RESULTS: 'Master Profile Search Results Available',
    REPORTING_PARTY_MASTER_SEARCH_RESULTS: 'Master Profile Search Results Available',
    TOW_VEHICLE_MASTER_SEARCH_RESULTS: 'Master Profile Search Results Available',
    TOW_VEHICLE_AUTO_INSURANCE_CARRIER: 'Auto Insurance Carrier',
    VEHICLE_MASTER_SEARCH_RESULTS: 'Master Profile Search Results Available',
    VEHICLE_AUTO_INSURANCE_CARRIER: 'Auto Insurance Carrier',
    INVOLVED_PERSON_AGE_MAX: 'Involved Person Age Max',
    INVOLVED_PERSON_AGE_MIN: 'Involved Person Age Min',
    INVOLVED_PERSON_DATE_OF_BIRTH: 'Involved Person Date of Birth',
    INVOLVED_PERSON_DATE_OF_BIRTH_UNKNOWN: 'Involved Person Date of Birth Unknown',
    INVOLVED_PERSON_DELETED: 'Involved Person Deleted',
    INVOLVED_PERSON_DRIVERS_LICENSE_NUMBER: 'Involved Person License Number',
    INVOLVED_PERSON_DRIVERS_LICENSE_STATE: 'Involved Person License State',
    INVOLVED_PERSON_EYE_COLOR: 'Involved Person Eye Color',
    INVOLVED_PERSON_FIRST_NAME: 'Involved Person First Name',
    INVOLVED_PERSON_HAIR_COLOR: 'Involved Person Hair Color',
    INVOLVED_PERSON_INVOLVEMENT_TYPE: 'Involved Person Involvement Type',
    INVOLVED_PERSON_LAST_NAME: 'Involved Person Last Name',
    INVOLVED_PERSON_NOTES: 'Involved Person Notes',
    INVOLVED_PERSON_PHONE_NUMBER: 'Involved Person Phone Number',
    INVOLVED_PERSON_PHONE_EXTENSION: 'Involved Person Phone Extension',
    INVOLVED_PERSON_RACE: 'Involved Person Race',
    INVOLVED_PERSON_SEX: 'Involved Person Sex',
    INVOLVED_PERSON_HEIGHT: 'Involved Person Height',
    INVOLVED_PERSON_HEIGHT_MAX: 'Involved Person Max Height',
    INVOLVED_PERSON_HEIGHT_MIN: 'Involved Person Min Height',
    INVOLVED_PERSON_WEIGHT: 'Involved Person Weight',
    INVOLVED_PERSON_WEIGHT_MAX: 'Involved Person Weight Max',
    INVOLVED_PERSON_WEIGHT_MIN: 'Involved Person Weight Min',
    INVOLVED_PERSON_LOCATION: 'Involved Person Location',
    INVOLVED_PERSON_LOCATION_SUB_PREMISE: 'Involved Person Location Sub-premise',
    INVOLVED_PERSON_SOCIAL_SECURITY_NUMBER: 'Involved Person Social Security Number',
    INVOLVED_PERSON_ADDRESS: 'Involved Person Address',
    INVOLVED_PERSON_ADDRESS_SUB_PREMISE: 'Involved Person Address Sub-premise',
    NEW_OTHER_ITEM: 'New Other Item',
    OTHER_ITEM_COLOR: 'Other Item Color',
    OTHER_ITEM_DESCRIPTION: 'Other Item Description',
    OTHER_ITEM_ITEM_CATEGORY: 'Other Item Item_Category',
    OTHER_ITEM_IDENTIFIER: 'Other Item Identifier',
    OTHER_ITEM_IDENTIFIER_TYPE: 'Other Item Identifier_Type',
    OTHER_ITEM_IDENTIFIER_TYPE_OTHER_DESCRIPTION: 'Other Item Identifier Type Other Description',
    OTHER_ITEM_MAKE: 'Other Item Make',
    OTHER_ITEM_MODEL: 'Other Item Model',
    OTHER_ITEM_QUANTITY: 'Other Item Quantity',
    OTHER_ITEM_SIZE: 'Other Item Size',
    OTHER_ITEM_SERIAL_NUMBER: 'Other Item Serial_Number',
    NEW_VEHICLE: 'New Vehicle',
    NEW_TOW_VEHICLE: 'New Tow Vehicle',
    VEHICLE_MAKE: 'Vehicle Make',
    VEHICLE_MODEL: 'Vehicle Model',
    VEHICLE_NOTES: 'Vehicle Notes',
    VEHICLE_PLATE_NUMBER: 'Vehicle Plate Number',
    VEHICLE_STATE: 'Vehicle State',
    VEHICLE_VIN_NUMBER: 'Vehicle VIN',
    VEHICLE_COLOR: 'Vehicle Color',
    VEHICLE_DELETED: 'Vehicle Deleted',
    VEHICLE_INVOLVEMENT_TYPE: 'Vehicle Involvement Type',
    VEHICLE_YEAR: 'Vehicle Year',
    TOW_VEHICLE_MAKE: 'Tow Vehicle Make',
    TOW_VEHICLE_MODEL: 'Tow Vehicle Model',
    TOW_VEHICLE_NOTES: 'Tow Vehicle Notes',
    TOW_VEHICLE_PLATE_NUMBER: 'Tow Vehicle Plate Number',
    TOW_VEHICLE_STATE: 'Tow Vehicle State',
    TOW_VEHICLE_VIN_NUMBER: 'Tow Vehicle VIN',
    TOW_VEHICLE_COLOR: 'Tow Vehicle Color',
    TOW_VEHICLE_INVOLVEMENT_TYPE: 'Tow Vehicle Involvement Type',
    TOW_VEHICLE_YEAR: 'Tow Vehicle Year',
    RISK_LEVEL: 'Risk Level',
    EVENT_STAFF_COUNT: 'E. Staff Count',
    UNIT_STAFF_COUNT: 'U. Staff Count',
    NEW_BOLO: 'New BOLO',
    BOLO_DESCRIPTION: 'BOLO Description',
    BOLO_BOLO_TYPE: 'BOLO Type',
    BOLO_DISPATCH_AREA_RECIPIENT: 'BOLO Dispatch Area Recipient',
    BOLO_LABEL: 'BOLO Label',
    BOLO_LOCATION: 'BOLO Location',
    BOLO_LOCATION_NOTES: 'BOLO Location Notes',
    BOLO_LOCATION_SUB_PREMISE: 'BOLO Location Sub-premise',
    BOLO_PRIORITY: 'BOLO Priority',
    BOLO_SCHEDULED_EXPIRATION_DATE: 'BOLO Scheduled Expiration Date',
    BOLO_SUBDIVISION_RECIPIENT: 'BOLO Subdivision Recipient',
    PRO_QA_URGENT: 'Urgent ProQA',
};

export const notificationTypeToEntityType: Record<
    CadNextNotificationTypeEnumType,
    CadNextNotificationEntityEnumType
> = {
    // Agency Event
    ADDITIONAL_CFS: 'AGENCY_EVENT',
    ADDITIONAL_RADIO_CHANNEL: 'AGENCY_EVENT',
    AGENCY: 'AGENCY_EVENT',
    ALARM_LEVEL: 'AGENCY_EVENT',
    ASSOCIATED_EVENT: 'AGENCY_EVENT',
    BEAT: 'AGENCY_EVENT',
    CFS: 'AGENCY_EVENT',
    CROSS_STREETS: 'AGENCY_EVENT',
    DISPATCH_AREA: 'AGENCY_EVENT',
    EVENT_LABELS: 'AGENCY_EVENT',
    EVENT_LOCATION: 'AGENCY_EVENT',
    EVENT_LOCATION_SUB_PREMISE: 'AGENCY_EVENT',
    EVENT_LOCATION_NOTES: 'AGENCY_EVENT',
    EVENT_MERGED: 'AGENCY_EVENT',
    EVENT_UNMERGED: 'AGENCY_EVENT',
    EVENT_PRIORITY: 'AGENCY_EVENT',
    EVENT_STAFF_COUNT: 'AGENCY_EVENT',
    LOCATION_CAUTION: 'AGENCY_EVENT',
    NEW_EVENT: 'AGENCY_EVENT',
    RADIO_CHANNEL: 'AGENCY_EVENT',
    RISK_LEVEL: 'AGENCY_EVENT',
    SUBDIVISION: 'AGENCY_EVENT',
    PHONE_CALL_GPS: 'AGENCY_EVENT',
    PHONE_CALL_CALLER_ADDRESS: 'AGENCY_EVENT',
    PHONE_CALL_CALLER_NAME: 'AGENCY_EVENT',
    // Reporting Party
    NEW_REPORTING_PARTY: 'REPORTING_PARTY',
    REPORTING_PARTY_FIRST_NAME: 'REPORTING_PARTY',
    REPORTING_PARTY_LAST_NAME: 'REPORTING_PARTY',
    REPORTING_PARTY_LOCATION: 'REPORTING_PARTY',
    REPORTING_PARTY_LOCATION_SUB_PREMISE: 'REPORTING_PARTY',
    REPORTING_PARTY_PHONE_NUMBER: 'REPORTING_PARTY',
    REPORTING_PARTY_NOTES: 'REPORTING_PARTY',
    REPORTING_PARTY_AGE_MAX: 'REPORTING_PARTY',
    REPORTING_PARTY_AGE_MIN: 'REPORTING_PARTY',
    REPORTING_PARTY_DATE_OF_BIRTH: 'REPORTING_PARTY',
    REPORTING_PARTY_DATE_OF_BIRTH_UNKNOWN: 'REPORTING_PARTY',
    REPORTING_PARTY_DRIVERS_LICENSE_NUMBER: 'REPORTING_PARTY',
    REPORTING_PARTY_DRIVERS_LICENSE_STATE: 'REPORTING_PARTY',
    REPORTING_PARTY_EYE_COLOR: 'REPORTING_PARTY',
    REPORTING_PARTY_HAIR_COLOR: 'REPORTING_PARTY',
    REPORTING_PARTY_INVOLVEMENT_TYPE: 'REPORTING_PARTY',
    REPORTING_PARTY_PHONE_EXTENSION: 'REPORTING_PARTY',
    REPORTING_PARTY_RACE: 'REPORTING_PARTY',
    REPORTING_PARTY_SEX: 'REPORTING_PARTY',
    REPORTING_PARTY_HEIGHT: 'REPORTING_PARTY',
    REPORTING_PARTY_HEIGHT_MAX: 'REPORTING_PARTY',
    REPORTING_PARTY_HEIGHT_MIN: 'REPORTING_PARTY',
    REPORTING_PARTY_WEIGHT: 'REPORTING_PARTY',
    REPORTING_PARTY_WEIGHT_MAX: 'REPORTING_PARTY',
    REPORTING_PARTY_WEIGHT_MIN: 'REPORTING_PARTY',
    REPORTING_PARTY_MASTER_SEARCH_RESULTS: 'REPORTING_PARTY',
    REPORTING_PARTY_SOCIAL_SECURITY_NUMBER: 'REPORTING_PARTY',
    REPORTING_PARTY_ADDRESS: 'REPORTING_PARTY',
    REPORTING_PARTY_ADDRESS_SUB_PREMISE: 'REPORTING_PARTY',
    // Involved Persons
    NEW_INVOLVED_PERSON: 'INVOLVED_PERSON',
    INVOLVED_PERSON_AGE_MAX: 'INVOLVED_PERSON',
    INVOLVED_PERSON_AGE_MIN: 'INVOLVED_PERSON',
    INVOLVED_PERSON_DATE_OF_BIRTH: 'INVOLVED_PERSON',
    INVOLVED_PERSON_DATE_OF_BIRTH_UNKNOWN: 'INVOLVED_PERSON',
    INVOLVED_PERSON_DELETED: 'INVOLVED_PERSON',
    INVOLVED_PERSON_DRIVERS_LICENSE_NUMBER: 'INVOLVED_PERSON',
    INVOLVED_PERSON_DRIVERS_LICENSE_STATE: 'INVOLVED_PERSON',
    INVOLVED_PERSON_EYE_COLOR: 'INVOLVED_PERSON',
    INVOLVED_PERSON_FIRST_NAME: 'INVOLVED_PERSON',
    INVOLVED_PERSON_HAIR_COLOR: 'INVOLVED_PERSON',
    INVOLVED_PERSON_INVOLVEMENT_TYPE: 'INVOLVED_PERSON',
    INVOLVED_PERSON_LAST_NAME: 'INVOLVED_PERSON',
    INVOLVED_PERSON_NOTES: 'INVOLVED_PERSON',
    INVOLVED_PERSON_PHONE_NUMBER: 'INVOLVED_PERSON',
    INVOLVED_PERSON_RACE: 'INVOLVED_PERSON',
    INVOLVED_PERSON_SEX: 'INVOLVED_PERSON',
    INVOLVED_PERSON_HEIGHT: 'INVOLVED_PERSON',
    INVOLVED_PERSON_HEIGHT_MAX: 'INVOLVED_PERSON',
    INVOLVED_PERSON_HEIGHT_MIN: 'INVOLVED_PERSON',
    INVOLVED_PERSON_WEIGHT: 'INVOLVED_PERSON',
    INVOLVED_PERSON_WEIGHT_MAX: 'INVOLVED_PERSON',
    INVOLVED_PERSON_WEIGHT_MIN: 'INVOLVED_PERSON',
    INVOLVED_PERSON_LOCATION: 'INVOLVED_PERSON',
    INVOLVED_PERSON_LOCATION_SUB_PREMISE: 'INVOLVED_PERSON',
    INVOLVED_PERSON_PHONE_EXTENSION: 'INVOLVED_PERSON',
    INVOLVED_PERSON_MASTER_SEARCH_RESULTS: 'INVOLVED_PERSON',
    INVOLVED_PERSON_SOCIAL_SECURITY_NUMBER: 'INVOLVED_PERSON',
    INVOLVED_PERSON_ADDRESS: 'INVOLVED_PERSON',
    INVOLVED_PERSON_ADDRESS_SUB_PREMISE: 'INVOLVED_PERSON',
    // Vehicles
    NEW_VEHICLE: 'VEHICLE',
    VEHICLE_MAKE: 'VEHICLE',
    VEHICLE_MODEL: 'VEHICLE',
    VEHICLE_NOTES: 'VEHICLE',
    VEHICLE_PLATE_NUMBER: 'VEHICLE',
    VEHICLE_STATE: 'VEHICLE',
    VEHICLE_VIN_NUMBER: 'VEHICLE',
    VEHICLE_COLOR: 'VEHICLE',
    VEHICLE_DELETED: 'VEHICLE',
    VEHICLE_INVOLVEMENT_TYPE: 'VEHICLE',
    VEHICLE_YEAR: 'VEHICLE',
    VEHICLE_MASTER_SEARCH_RESULTS: 'VEHICLE',
    VEHICLE_AUTO_INSURANCE_CARRIER: 'VEHICLE',

    // Tow Vehicles
    NEW_TOW_VEHICLE: 'TOW_VEHICLE',
    TOW_VEHICLE_MAKE: 'TOW_VEHICLE',
    TOW_VEHICLE_MODEL: 'TOW_VEHICLE',
    TOW_VEHICLE_NOTES: 'TOW_VEHICLE',
    TOW_VEHICLE_PLATE_NUMBER: 'TOW_VEHICLE',
    TOW_VEHICLE_STATE: 'TOW_VEHICLE',
    TOW_VEHICLE_VIN_NUMBER: 'TOW_VEHICLE',
    TOW_VEHICLE_COLOR: 'TOW_VEHICLE',
    TOW_VEHICLE_INVOLVEMENT_TYPE: 'TOW_VEHICLE',
    TOW_VEHICLE_YEAR: 'TOW_VEHICLE',
    TOW_VEHICLE_MASTER_SEARCH_RESULTS: 'TOW_VEHICLE',
    TOW_VEHICLE_AUTO_INSURANCE_CARRIER: 'TOW_VEHICLE',
    // Additional Info
    NARRATIVE: 'ADDITIONAL_INFO',
    PRO_QA_URGENT: 'ADDITIONAL_INFO',
    // Unit
    UNIT_STAFF_COUNT: 'UNIT',
    // Firearms
    NEW_FIREARM: 'FIREARM',
    FIREARM_ALTERATION_INDICATED: 'FIREARM',
    FIREARM_CALIBER: 'FIREARM',
    FIREARM_FIREARM_TYPE: 'FIREARM',
    FIREARM_MAKE: 'FIREARM',
    FIREARM_DESCRIPTION: 'FIREARM',
    FIREARM_IDENTIFIER: 'FIREARM',
    FIREARM_IDENTIFIER_TYPE: 'FIREARM',
    FIREARM_IDENTIFIER_TYPE_OTHER_DESCRIPTION: 'FIREARM',
    FIREARM_MODEL: 'FIREARM',
    FIREARM_REGISTRATION_NUMBER: 'FIREARM',
    FIREARM_SERIAL_NUMBER: 'FIREARM',
    // Drugs
    NEW_DRUGS: 'DRUGS',
    DRUGS_DRUG_CATEGORY: 'DRUGS',
    DRUGS_DESCRIPTION: 'DRUGS',
    DRUGS_IDENTIFIER: 'DRUGS',
    DRUGS_IDENTIFIER_TYPE: 'DRUGS',
    DRUGS_IDENTIFIER_TYPE_OTHER_DESCRIPTION: 'DRUGS',
    DRUGS_IS_PRECURSOR_CHEMICAL: 'DRUGS',
    DRUGS_MEASUREMENT_UNITS: 'DRUGS',
    DRUGS_QUANTITY: 'DRUGS',
    // Other Item
    NEW_OTHER_ITEM: 'OTHER_ITEM',
    OTHER_ITEM_COLOR: 'OTHER_ITEM',
    OTHER_ITEM_DESCRIPTION: 'OTHER_ITEM',
    OTHER_ITEM_ITEM_CATEGORY: 'OTHER_ITEM',
    OTHER_ITEM_IDENTIFIER: 'OTHER_ITEM',
    OTHER_ITEM_IDENTIFIER_TYPE: 'OTHER_ITEM',
    OTHER_ITEM_IDENTIFIER_TYPE_OTHER_DESCRIPTION: 'OTHER_ITEM',
    OTHER_ITEM_MAKE: 'OTHER_ITEM',
    OTHER_ITEM_MODEL: 'OTHER_ITEM',
    OTHER_ITEM_QUANTITY: 'OTHER_ITEM',
    OTHER_ITEM_SIZE: 'OTHER_ITEM',
    OTHER_ITEM_SERIAL_NUMBER: 'OTHER_ITEM',
    // Bolo
    NEW_BOLO: 'BOLO',
    BOLO_DESCRIPTION: 'BOLO',
    BOLO_BOLO_TYPE: 'BOLO',
    BOLO_DISPATCH_AREA_RECIPIENT: 'BOLO',
    BOLO_LABEL: 'BOLO',
    BOLO_LOCATION: 'BOLO',
    BOLO_LOCATION_NOTES: 'BOLO',
    BOLO_LOCATION_SUB_PREMISE: 'BOLO',
    BOLO_PRIORITY: 'BOLO',
    BOLO_SCHEDULED_EXPIRATION_DATE: 'BOLO',
    BOLO_SUBDIVISION_RECIPIENT: 'BOLO',
};
